<div *ngFor="let report of reportMangerList; let i=index" class="d-grid gap-2 w-100">
    <ng-container *ngIf="report.children">
      <kendo-expansionpanel [dir]="isRight ? 'rtl': 'auto'" expandIcon="k-i-arrow-chevron-down"
        collapseIcon="k-i-arrow-chevron-right" tabindex="-1"
        [expanded]="childExpandedPanels[selectedItem] === i"
        (expandedChange)="childExpandedPanels[selectedItem] = $event ? i : -1"
        [title]="report.text | translate" class="child-expansion border-0">

        <bi-child-report [ChildReports]="report.children"></bi-child-report>
      </kendo-expansionpanel>
    </ng-container>
  </div>

